export const faqs = [
  {
    question: '鲍鱼网址域名是什么？',
    answer: '鲍鱼网址域名是用户快速访问鲍鱼平台的官方通道，是由鲍鱼平台官方管理和维护的网站地址。通过官方域名，用户可以安全地访问鲍鱼平台进行注册、登录和使用各项服务。我们建议用户始终通过官方域名访问，避免使用来源不明的第三方链接。',
  },
  {
    question: '如何确认当前访问的是鲍鱼官方网站？',
    answer: '确认官方网站的方法包括：1）检查浏览器地址栏是否有安全锁图标（HTTPS加密）；2）核对网址拼写是否与官方公布的域名完全一致；3）查看网站底部是否有ICP备案号；4）通过官方APP或客服渠道核实当前域名。如果发现任何异常，请立即停止操作并联系官方客服。',
  },
  {
    question: '鲍鱼域名多久更新一次？',
    answer: '鲍鱼域名的更新频率并不固定，通常在出现以下情况时进行更新：平台品牌升级、域名备案信息变更、DNS服务器优化迁移、安全防御需求等。平台会通过官方APP推送、邮件通知、社交媒体公告等多种渠道提前通知用户域名变更信息。',
  },
  {
    question: '域名失效了怎么办？',
    answer: '如果发现当前使用的域名无法访问，请按以下步骤操作：1）尝试使用已收藏的备用域名；2）打开官方APP获取最新域名；3）查看注册邮箱中的域名更新通知；4）联系官方客服获取最新访问地址。建议平时多收藏几个备用域名，并关注官方通知渠道。',
  },
  {
    question: '注册鲍鱼账号需要哪些信息？',
    answer: '注册鲍鱼账号需要提供以下信息：有效的手机号码或电子邮箱地址、自定义登录密码（建议8位以上，包含大小写字母和数字）、同意用户协议和隐私政策。部分情况下可能需要进行实名认证。注册过程完全免费，不会收取任何费用。',
  },
  {
    question: '如何避免访问到钓鱼域名？',
    answer: '避免访问钓鱼域名的方法包括：始终从官方渠道获取域名地址，不要点击来路不明的链接；仔细核对网址拼写，特别注意是否存在字符替换；检查网页设计质量，钓鱼网站通常制作粗糙；使用浏览器的安全浏览功能；遇到可疑网站时立即向官方举报。',
  },
];